import { render, staticRenderFns } from "./NewField.vue?vue&type=template&id=5999931e&scoped=true&"
import script from "./NewField.vue?vue&type=script&lang=js&"
export * from "./NewField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999931e",
  null
  
)

export default component.exports